import * as React from 'react'

import * as api from '@owl-nest/api-client/next'

export function useUserWithToken(token: string | undefined) {
  const [user, setUser] = React.useState<api.AuthenticatedUser<''> | undefined>(undefined)

  React.useEffect(() => {
    if (token) {
      getUser(token).then((response) => {
        response.caseOf({
          right: (value) => {
            setUser(value.body)
          },
          left: () => {
            setUser(undefined)
          },
        })
      })
    }
  }, [token])

  return user
}

async function getUser(token: string) {
  const response = await api.client('GET /me', { token })

  return response.next((value) => {
    return value
  })
}
